import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'

import { userTimeZoneFormat, shortAbbr } from 'utils/time'
import colors from 'components/utils/colors'
import { RouteProfile } from 'routes'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`

const GreetingLine = styled.h1`
  font-family: Exo;
  font-size: 20px;
  line-height: 26px;
  color: ${colors.secondary20};
`

const SignedAsLine = styled.div`
  font-size: 14px;
  padding-top: 6px;
`

const DateTimeLine = styled.div`
  font-size: 14px;
  padding-top: 10px;
`

const TimeZone = styled.span`
  font-weight: 600;
  text-transform: capitalize;
`

const RoleOrPartner = styled.span`
  font-weight: 600;
  text-transform: capitalize;
`

const Userbox = () => {
  const [currentTime, setCurrentTime] = useState(new Date())

  const { t } = useTranslation()

  const userIsAnyAdmin = useSelector(sessionUserSelector.isAnyAdmin)
  const userIsAdminImpersonatedRole = useSelector(sessionUserSelector.isAdminImpersonatedRole)
  const userRole = useSelector(sessionUserSelector.role)
  const userPartnerName = useSelector(sessionUserSelector.partnerName)
  const userDisplayName = useSelector(sessionUserSelector.displayName)
  const userTimeZone = useSelector(sessionUserSelector.timezone)

  useEffect(
    () => {
      const timerId = setInterval(() => {
        setCurrentTime(new Date())
      }, 1000)

      return () => {
        clearInterval(timerId)
      }
    },
    []
  )

  let impersonationInfo, roleOrPartnerName
  // TODO: Remove this part. Admins cannot see Dashboard page and Userbox.
  if (userIsAnyAdmin) {
    roleOrPartnerName = userRole === 'admin' ? t('dashboardPage.adminRole') : t('dashboardPage.adminRoRole')
    if (userIsAdminImpersonatedRole) {
      impersonationInfo = (
        <>
          | {t('dashboardPage.impersonate')}: <RoleOrPartner>{userPartnerName}</RoleOrPartner>
        </>
      )
    }
  } else {
    roleOrPartnerName = userPartnerName
  }

  return (
    <StyledWrapper>
      <GreetingLine data-test='userbox-greeting'>
        {t('dashboardPage.greeting')} {userDisplayName}
      </GreetingLine>
      <SignedAsLine data-test='userbox-signed-as'>
        {t('dashboardPage.signedAs')} <RoleOrPartner>{roleOrPartnerName}</RoleOrPartner> {impersonationInfo}
      </SignedAsLine>
      <DateTimeLine data-test='userbox-datetime'>
        {userTimeZoneFormat(userTimeZone, currentTime, 'human_without_tz') + ' '}
        <TimeZone>
          <Link to={RouteProfile()}>{shortAbbr(userTimeZone)}</Link>
        </TimeZone>

      </DateTimeLine>
    </StyledWrapper>
  )
}

export default Userbox
